import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	toolbarName: {
		id: 'floating-toolbar.common.toolbar-name',
		defaultMessage: 'Bulk actions',
		description: 'The text will show when the toolbar is focused',
	},
});
